import React, { useState } from "react";
import { Card, Box, Alert, Typography } from "@mui/material";
import BannerTop from "../../components/BannerTop/BannerTop";
import { l } from "../../libs/localization";
import "./profile.style.scss";
import Button from "../../design-library/Button/Button.component";
import TextField from "../../design-library/TextField/TextField.component";
import CopyOutlined from "@ant-design/icons/es/icons/CopyOutlined";

import { get } from "../../libs/helpers/ioc";
import Config from "../../Config";

function ProfileApiKeyPage() {
  const [copied, setCopied] = useState(false);

  const permissions = get("scopes") || {};
  const hasMcpPermission = !!permissions.mcp;

  // The Blinko MCP server lives in the API. Clients sign in through the usual Blinko login and
  // consent page: there is no key to copy anymore.
  let origin = Config.apiBaseurl;
  try {
    origin = new URL(Config.apiBaseurl).origin;
  } catch (e) {}
  const mcpUrl = `${origin}/mcp/blinko`;

  function handleCopy() {
    navigator.clipboard.writeText(mcpUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div className="profilePage">
      <BannerTop small variant="profile">
        <h1 className="mt-4 title">{l("PROFILE.API_KEY")}</h1>
      </BannerTop>

      <Card
        sx={{
          p: 6,
          mt: -6,
          position: "relative",
          boxShadow: "0px 4px 10px 0px #00000026",
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        {!hasMcpPermission ? (
          <Alert severity="warning" sx={{ alignSelf: "stretch" }}>
            {l("PROFILE.API_KEY_NO_PERMISSION")}
          </Alert>
        ) : (
          <>
            <Typography variant="body1" sx={{ color: "#555" }}>
              {l("PROFILE.API_KEY_URL_DESC")}
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "stretch", md: "flex-end" },
                gap: 2,
                width: "100%",
              }}
            >
              <Box sx={{ flexGrow: 1 }}>
                <TextField
                  placeholder={l("PROFILE.API_KEY_URL")}
                  label={l("PROFILE.API_KEY_URL")}
                  value={mcpUrl}
                  disabled
                />
              </Box>

              <Button sx={{ height: 40 }} onClick={handleCopy}>
                <CopyOutlined style={{ marginRight: 8 }} />
                {copied ? l("PROFILE.API_KEY_URL_COPIED") : l("PROFILE.API_KEY_URL_COPY")}
              </Button>
            </Box>
          </>
        )}
      </Card>
    </div>
  );
}

export default ProfileApiKeyPage;
